/**
 * Shown when the host has gone quiet and the server has widened control to
 * every remaining player.
 *
 * The point is that the extra button is EXPLAINED. A control that silently
 * appears because of a timeout somewhere is indistinguishable from a bug, and
 * the player who taps it should know why they suddenly can.
 *
 * Deliberately cool-toned: this is a status readout, not a call to action.
 * Warm colour in this design is wayfinding only, and nothing here advances you
 * — the button underneath it does that.
 */
export function HostAbsentNotice() {
  return (
    <p className="inset bd-pad t-micro" role="status" aria-live="polite">
      Host disconnected &mdash; anyone can continue.
    </p>
  );
}
